module.exports = __webpack_public_path__ + "img/check.681f0b9a.png";